import React from "react";
import { Helmet } from "react-helmet-async";

const Doprava = () => {
  const renderContent = () => {
    return (
      <div
        id="single-entry-content"
        className="prose prose-sm !max-w-screen-md sm:prose lg:prose-lg mx-auto dark:prose-invert"
      >
        <div className="outer-container" id="article_text">
          <h1 className="text-center">Doprava</h1>

          <h2>Slovensko</h2>

          <h3>Spôsoby doručenia a ceny</h3>

          <h4>Platba vopred (bankový prevod)</h4>
          <ul>
            <li>GLS kuriér: <strong>3,90 €</strong></li>
            <li>GLS/AlzaBox výdajné miesto: <strong>2,90 €</strong></li>
          </ul>

          <h4>Dobierka</h4>
          <ul>
            <li>GLS kuriér: <strong>4,90 €</strong></li>
            <li>GLS/AlzaBox výdajné miesto: <strong>3,90 €</strong></li>
          </ul>

          <p className="text-green-600 font-semibold">
            Doprava zdarma pri objednávke nad 60 €
          </p>

          <h3>Možnosti platby na výdajných miestach</h3>
          <ul>
            <li>Parcel boxy s dotykovou obrazovkou - platba kartou</li>
            <li>Štandardné parcel boxy a AlzaBox - platba cez GLS mobilnú aplikáciu</li>
            <li>ParcelShop - platba v hotovosti</li>
          </ul>

          <h3>Dôležité upozornenie</h3>
          <p>
            Nadrozmerné balíky: Možnosti doručenia na odberné miesto GLS nie sú dostupné.
          </p>

          <h3>Bankové údaje</h3>
          <p>
            <strong>Banka:</strong> FIO banka<br />
            <strong>IBAN:</strong> SK69 8330 0000 0024 0079 2210
          </p>

          <hr className="my-8" />

          <h2>Česká republika</h2>

          <h3>Spôsoby doručenia a ceny</h3>

          <h4>Platba vopred (bankový prevod)</h4>
          <ul>
            <li>GLS kuriér: <strong>8,90 €</strong></li>
            <li>GLS/AlzaBox výdajné miesto: <strong>5,90 €</strong></li>
          </ul>

          <p className="text-green-600 font-semibold">
            Doprava zdarma pri objednávke nad 60 €
          </p>

          <h3>Bankové údaje</h3>
          <p>
            <strong>Banka:</strong> FIO banka<br />
            <strong>IBAN:</strong> CZ58 2010 0000 0024 0079 2210
          </p>
        </div>
      </div>
    );
  };

  return (
    <div className="nc-PageSingle pt-8 lg:pt-16 ">
      <Helmet>
        <title>Doprava || MojaVec</title>
      </Helmet>

      <div className="nc-SingleContent container space-y-10 bg-white p-5">
        {renderContent()}
      </div>
    </div>
  );
};

export default Doprava;
